// extracted by mini-css-extract-plugin
module.exports = {"error":"BetSlipError_error__GmMEA","warning":"BetSlipError_warning__2Sbs_"};